module.exports = __webpack_public_path__ + "static/img/jkfa_jcjg_btn.png";